// src/Public/search-data.js

const SearchData = {
    en: {
        triggerAria: 'Search',
        title: 'Search Console',
        subtitle: 'Categories • Services • Parts',
        typeLabels: {
            product: 'Part',
            service: 'Service',
            category: 'Category',
            project: 'Project',
            blog: 'Blog',
        },
        closeAria: 'Close search window',
        placeholder: 'Search inventory & categories...',
        desktopPlaceholder: 'Search Inventory & Categories...',
        mobilePlaceholder: 'Search products & categories...',
        startTyping: 'Start typing to see search results.',
        noResults: 'No registry matches found',
        exploreSuggestion: 'Explore',
        fallbackSuggestions: ['Search Categories...', 'Find Spare Parts...'],
    },

    he: {
        triggerAria: 'חיפוש',
        title: 'חיפוש',
        subtitle: 'קטגוריות • שירותים • חלקים',
        typeLabels: {
            product: 'מוצר',
            service: 'שירות',
            category: 'קטגוריה',
            project: 'פרויקט',
            blog: 'בלוג',
        },
        closeAria: 'סגירת חלון חיפוש',
        placeholder: 'חפש מלאי וקטגוריות...',
        desktopPlaceholder: 'חיפוש מלאי וקטגוריות...',
        mobilePlaceholder: 'חפש מוצרים וקטגוריות...',
        startTyping: 'התחילו להקליד כדי לראות תוצאות חיפוש.',
        noResults: 'לא נמצאו תוצאות',
        exploreSuggestion: 'עיין ב',
        fallbackSuggestions: ['חפש קטגוריות...', 'מצא חלקי חילוף...'],
    }
};

function resolveLanguage(language) {
    return language === 'he' ? 'he' : 'en';
}

export function getSearchData(language) {
    const lang = resolveLanguage(language);
    return SearchData[lang] || SearchData.en;
}

export default SearchData;